<div class="signup signup-wrapper">
  <app-header></app-header>

  <div class="signup signup-container" *ngIf="!Msg">
    <div class="signup signup-box">
      <!-- Logo Section -->
      <div class="signup signup-logo-section">
        <img src="assets/icon/gigsumologo_bigface.png" alt="Gigsumo" class="signup signup-logo">
      </div>

      <!-- Welcome Text -->
      <div class="signup signup-welcome-text">
        <h1>Welcome to gigsumo.com</h1>
        <p>Free Lifetime Membership. No credit card needed.</p>
      </div>

      <!-- Signup Form -->
      <form [formGroup]="signupForm" (ngSubmit)="signUp()" class="signup signup-form" *ngIf="!Msg">
        <!-- Error Messages -->
        <div class="signup signup-error-message" *ngIf="MsgFailed">
          <ng-icon name="tablerAlertCircle"></ng-icon>
          User has been already registered for this email.
          <a [routerLink]="['/auth/login']">Sign In</a> or
          <a [routerLink]="['/auth/Forgotpassword']">Reset Password</a>
        </div>

        <div class="signup signup-error-message" *ngIf="signupCheckEmail">
          <ng-icon name="tablerInfoCircle"></ng-icon>
          You have already signed up. Please check your email to complete registration.
        </div>

        <!-- Google Signup -->
        <button type="button" class="signup signup-btn-google" tabindex="1" 
          (click)="redirectToGoogle()"
          (focus)="$event.target.classList.add('focused')"
          (blur)="$event.target.classList.remove('focused')">
          <img src="assets/images/g-logo.png" alt="Google">
          <span>Continue with Google</span>
        </button>

        <!-- Divider -->
        <div class="signup signup-divider-section">
          <span class="signup signup-divider-text">OR</span>
        </div>

        <!-- Name Fields -->
        <div class="signup signup-name-row">
          <div class="signup signup-input-group signup-half-width">
            <input type="text" class="signup signup-form-input" placeholder="Enter First Name"
              formControlName="firstName" id="signup_firstName" #usernameInput maxlength="21" tabindex="2"
              (keypress)="checkspace($event)"
              (focus)="$event.target.select()"
              [class.error]="e.firstName.invalid && (e.firstName.dirty || e.firstName.touched)">
            <span class="signup signup-input-icon">
              <ng-icon name="tablerUser"></ng-icon>
            </span>
            <div class="signup signup-field-error"
              *ngIf="e.firstName.invalid && (e.firstName.dirty || e.firstName.touched)">
              <span *ngIf="e.firstName.errors.required">First Name is required</span>
              <span *ngIf="e.firstName.errors.minword">{{FORMERROR.FIRSTNAME_MIN}}</span>
              <span *ngIf="e.firstName.errors.maxword">{{FORMERROR.FIRSTNAME_MAX}}</span>
              <span *ngIf="e.firstName.errors.pattern && !e.firstName.errors.maxword">First Name must contain alphabet
                only</span>
            </div>
          </div>

          <div class="signup signup-input-group signup-half-width">
            <input type="text" class="signup signup-form-input" placeholder="Enter Last Name" formControlName="lastName"
              id="signup_lastName" maxlength="41" tabindex="3" (keypress)="checkspace($event)"
              (focus)="$event.target.select()"
              [class.error]="e.lastName.invalid && (e.lastName.dirty || e.lastName.touched)">
            <span class="signup signup-input-icon">
              <ng-icon name="tablerUser"></ng-icon>
            </span>
            <div class="signup signup-field-error"
              *ngIf="e.lastName.invalid && (e.lastName.dirty || e.lastName.touched)">
              <span *ngIf="e.lastName.errors.required">Last Name is required</span>
              <span *ngIf="e.lastName.errors.minword">{{FORMERROR.LASTNAME_MIN}}</span>
              <span *ngIf="e.lastName.errors.maxword">{{FORMERROR.LASTNAME_MAX}}</span>
              <span *ngIf="e.lastName.errors.pattern && !e.lastName.errors.maxword">Last Name must contain alphabet
                only</span>
            </div>
          </div>
        </div>

        <!-- Email Input -->
        <div class="signup signup-input-group">
          <input type="email" class="signup signup-form-input" placeholder="Enter Email Address" formControlName="email"
            id="signup_email" maxlength="51" tabindex="4"
            (focus)="$event.target.select()" [class.error]="e.email.invalid && (e.email.dirty || e.email.touched)">
          <span class="signup signup-input-icon">
            <ng-icon name="tablerMail"></ng-icon>
          </span>
          <div class="signup signup-field-error" *ngIf="e.email.invalid && (e.email.dirty || e.email.touched)">
            <span *ngIf="e.email.errors.required">Email Address is required</span>
            <span *ngIf="e.email.errors.pattern && !e.email.errors.maxword">{{FORMERROR.EMAIL_VALID}}</span>
            <span *ngIf="e.email.errors.maxword">{{FORMERROR.EMAIL_MAX}}</span>
          </div>
        </div>

        <!-- Terms Checkbox -->
        <div class="signup signup-terms-section">
          <label class="signup signup-terms-check">
            <input type="checkbox" formControlName="Terms" id="signup_terms" tabindex="5">
            <span>
              By creating an account, you agree to the
              <a href="{{ENVIRONMENT.ssrUrl}}web/terms-conditions.html" target="_blank">Terms of Service</a>
              and
              <a href="{{ENVIRONMENT.ssrUrl}}web/privacy-policy.html" target="_blank">Privacy Policy</a>
            </span>
          </label>
          <div class="signup signup-field-error"
            *ngIf="(e.Terms.errors?.required || !signupForm.value.Terms) && e.Terms.touched">
            Please accept Terms Of Service, Privacy Policy
          </div>
        </div>

        <!-- Create Account Button -->
        <button type="submit" class="signup signup-btn-primary" id="signup-button" tabindex="6"
          (focus)="$event.target.classList.add('focused')"
          (blur)="$event.target.classList.remove('focused')">
          Create my free account
        </button>
      </form>

      <!-- Login Link -->
      <div class="signup signup-login-section" *ngIf="!Msg">
        <span>Already have a Gigsumo account?</span>
        <a [routerLink]="['/auth/login']" tabindex="7">Sign In</a>
      </div>
    </div>
  </div>

  <!-- Success Message -->
  <div class="signup signup-success-container" *ngIf="Msg">
    <div class="signup signup-success-box">
      <!-- Logo Section -->
      <div class="signup signup-logo-section">
        <img src="assets/icon/gigsumologo_bigface.png" alt="Gigsumo" class="signup signup-logo">
      </div>

      <!-- Email Icon Section -->
      <div class="signup signup-success-icon">
        <img src="assets/newassets/images/mail.png" alt="Email" class="signup signup-email-img">
      </div>

      <!-- Success Message -->
      <div class="signup signup-welcome-text">
        <h1>Great, please check your email!</h1>
        <p>We've sent you an activation link to complete your registration.</p>
      </div>

      <!-- Email Instructions -->
      <div class="signup signup-success-note-box">
        <h4>Please Note:</h4>
        <div class="signup signup-success-list">
          <div class="signup signup-instruction-item">
            <i class="signup signup-instruction-icon"></i>
            <span>You will receive an activation link to the email you provided.</span>
          </div>
          <div class="signup signup-instruction-item">
            <i class="signup signup-instruction-icon"></i>
            <span>The email will be valid for 24 hours.</span>
          </div>
          <div class="signup signup-instruction-item">
            <i class="signup signup-instruction-icon"></i>
            <span>Don't see an email after 10 minutes?</span>
          </div>
          <div class="signup signup-instruction-item">
            <i class="signup signup-instruction-icon"></i>
            <span>Check your spam folder for an email from <a class="signup signup-email-highlight">noreply@gigsumo.com</a></span>
          </div>
        </div>
      </div>

      <!-- Action Button -->
        <button type="button" class="signup signup-btn-primary" [routerLink]="['/auth/login']" routerLinkActive="router-link-active">
          Back to Sign In
        </button>
    </div>
  </div>